"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsersHttpService = void 0;
const types_1 = require("../../types");
const update_user_profile_1 = require("../../types/users/update-user-profile");
const http_service_1 = require("../http.service");
class UsersHttpService extends http_service_1.HttpService {
    constructor(apiUrl) {
        super(`${apiUrl}/users`);
    }
    getMe(_) {
        return this.getEntity('me', {
            schema: types_1.getMeResponseApiSchema,
        });
    }
    updateProfile(payload) {
        return this.putEntity('profile', {
            body: payload,
            schema: update_user_profile_1.updateUserProfileResponseApiSchema,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }
    getCsmList() {
        return this.get('csm', {
            schema: types_1.listCsmUsersApiResponseSchema,
        });
    }
    getOfficeAssignments(userId) {
        return this.get(`${userId}/office-assignments`);
    }
    addOfficeAssignment(payload) {
        return this.post(`${payload.userId}/office-assignments`, {
            body: {
                officeId: payload.officeId,
            },
        });
    }
}
exports.UsersHttpService = UsersHttpService;
